"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockMoveAction = void 0;
var lodash_1 = __importDefault(require("lodash"));
var BlockMoveAction;
(function (BlockMoveAction) {
    BlockMoveAction["Up"] = "up";
    BlockMoveAction["Down"] = "down";
    BlockMoveAction["Remove"] = "remove";
    BlockMoveAction["Insert"] = "insert";
})(BlockMoveAction = exports.BlockMoveAction || (exports.BlockMoveAction = {}));
exports.default = (function (updateBlockOrder) {
    var conflictResolver = function (errorResponse, pendingOperations) {
        var e_1, _a;
        var currentState = errorResponse.additionalInfo.order;
        var version = errorResponse.additionalInfo.version;
        var updatedOperations = [];
        try {
            for (var pendingOperations_1 = __values(pendingOperations), pendingOperations_1_1 = pendingOperations_1.next(); !pendingOperations_1_1.done; pendingOperations_1_1 = pendingOperations_1.next()) {
                var op = pendingOperations_1_1.value;
                var updatedOp = redoAction(op.move, currentState);
                if (updatedOp != null) {
                    currentState = updatedOp.payload;
                    updatedOperations.push(updatedOp);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (pendingOperations_1_1 && !pendingOperations_1_1.done && (_a = pendingOperations_1.return)) _a.call(pendingOperations_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (updatedOperations.length > 0) {
            updateBlockOrder(version, updatedOperations[updatedOperations.length - 1].payload);
        }
        return {
            newVersion: version,
            conflictResolution: updatedOperations,
        };
    };
    var redoAction = function (move, state) {
        state = lodash_1.default.cloneDeep(state);
        switch (move.action) {
            case BlockMoveAction.Up:
                return redoUp(move.blockId, move.context, state);
            case BlockMoveAction.Down:
                return redoDown(move.blockId, move.context, state);
            case BlockMoveAction.Remove:
                return redoRemove(move.blockId, move.context, state);
            case BlockMoveAction.Insert:
                return redoInsert(move.blockId, move.context, state);
        }
    };
    var redoUp = function (blockId, context, state) {
        var index = state.indexOf(blockId);
        if (index <= 0) {
            return;
        }
        if (!context.between || !context.between.second) {
            return;
        }
        var indexSecond = state.indexOf(context.between.second);
        if (indexSecond < 0 || index < indexSecond) {
            return;
        }
        moveTo(state, blockId, indexSecond);
        var newPosition = state.indexOf(blockId);
        var neighbours = {};
        if (newPosition > 0) {
            neighbours.first = state[newPosition - 1];
        }
        neighbours.second = state[newPosition + 1];
        var updatedContext = {
            position: newPosition,
            between: neighbours,
        };
        return createBlockHack(state, blockId, BlockMoveAction.Up, updatedContext);
    };
    var redoDown = function (blockId, context, state) {
        var index = state.indexOf(blockId);
        if (index < 0 || index === state.length - 1) {
            return;
        }
        if (!context.between || !context.between.first) {
            return;
        }
        var indexFirst = state.indexOf(context.between.first);
        if (indexFirst >= 0 && index < indexFirst) {
            moveTo(state, blockId, indexFirst);
        }
        else {
            return;
        }
        var newPosition = state.indexOf(blockId);
        var neighbours = {};
        neighbours.first = state[newPosition - 1];
        if (newPosition < state.length - 1) {
            neighbours.second = state[newPosition + 1];
        }
        var updatedContext = {
            position: newPosition,
            between: neighbours,
        };
        return createBlockHack(state, blockId, BlockMoveAction.Down, updatedContext);
    };
    var redoInsert = function (blockId, context, state) {
        var position = context.position;
        if (state.length === 0) {
            state.push(blockId);
        }
        else {
            var aboveIndex = !!context.between && !!context.between.first ? state.indexOf(context.between.first) : -1;
            var belowIndex = !!context.between && !!context.between.second ? state.indexOf(context.between.second) : -1;
            if (aboveIndex >= 0) {
                state.splice(aboveIndex + 1, 0, blockId);
            }
            else if (belowIndex >= 0) {
                state.splice(belowIndex, 0, blockId);
            }
            else {
                state.splice(position, 0, blockId);
            }
        }
        var insertedPosition = state.indexOf(blockId);
        var neighbours = {};
        if (insertedPosition > 0) {
            neighbours.first = state[insertedPosition - 1];
        }
        if (insertedPosition < state.length - 1) {
            neighbours.second = state[insertedPosition + 1];
        }
        var updatedContext = {
            position: insertedPosition,
            between: neighbours,
        };
        return createBlockHack(state, blockId, BlockMoveAction.Insert, updatedContext);
    };
    var redoRemove = function (blockId, context, state) {
        var index = state.indexOf(blockId);
        if (index < 0) {
            return;
        }
        else {
            state.splice(index, 1);
            var updatedContext = {
                position: index,
            };
            return createBlockHack(state, blockId, BlockMoveAction.Remove, updatedContext);
        }
    };
    var moveTo = function (state, blockId, newPosition) {
        var curr = state.indexOf(blockId);
        state.splice(curr, 1);
        state.splice(newPosition, 0, blockId);
    };
    var createBlockHack = function (payload, blockId, action, context) {
        return {
            payload: payload,
            move: {
                blockId: blockId,
                action: action,
                context: context,
            },
        };
    };
    return conflictResolver;
});
